import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { devConfig } from 'config/config'; // Importing development configuration from the config module

/**
 * Represents the tableExpensesView class, extending JetView.
 * This class is responsible for managing the expenses table view.
 */
export default class tableExpensesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            id: 'datatable', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
            columns: [
                {
                    id: 'rating', // Column identifier
                    header: '', // Column header (empty for icon)
                    width: 50, // Column width
                    height: 25, // Row height
                    tooltip: 'Editar', // Tooltip text for the column
                    template: function(obj) {
                        // Template function to render the column
                        return '<span class=\'webix_icon wxi-close edit\'></span>'; // Return edit icon
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column with sorting
                {
                    id: 'Consecutive', // Consecutive number column
                    header: 'Consecutivo', // Column header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Description', // Description column
                    header: 'Descripción', // Column header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'CreatedLocalDate', // Created local date column
                    header: _('Fecha de Creación'), // Localized column header
                    fillspace: 0, // Fill space option
                    minWidth: 0, // Minimum width
                    width: 150, // Column width
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date formatting function
                },
                {
                    id: 'TypeEgress', // Type of egress column
                    header: 'Tipo de Egreso', // Column header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'DocumentID', // Document ID column
                    header: 'Documento ID', // Column header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Concept', header: 'Concepto', width: 150, sort: 'int' }, // Concept column
                { id: 'Value', header: 'Valor', width: 150, sort: 'int' }, // Value column
                { id: 'Iva', header: 'IVA', width: 150, sort: 'int' }, // IVA column
                {
                    id: 'Retraccion', // Retraction column
                    header: 'Retracción', // Column header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handler for click on edit icon
                edit: function(euv, id) {
                    $$('EditExpenses').show(); // Show the edit expenses form
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Identifier for the pager component
            // API endpoint for fetching expenses data
            url: devConfig.geturlApi() + 'BetShop/GetExpenses?FromId=' + cur_user + '&',
            data: [
                // Sample data for the datatable
                {
                    Id: '01', // Unique identifier
                    IsBetShop: 0, // Indicator if it's a bet shop
                    CreatedLocalDate: '2019-02-03', // Creation date
                    Description: 'Compra', // Description of the expense
                    TypeEgress: 'Tipo Egreso 1', // Type of egress
                    DocumentID: '1010', // Document ID
                    Value: '100', // Value of the expense
                    Iva: '10', // IVA amount
                    Retraccion: '10', // Retraction amount
                    Concept: 'Concepto 1', // Concept of the expense
                },
                {
                    Id: '02', // Unique identifier
                    IsBetShop: 1, // Indicator if it's a bet shop
                    Description: 'Servicio', // Description of the expense
                    CreatedLocalDate: '2019-02-03', // Creation date
                    TypeEgress: 'Tipo Egreso 2', // Type of egress
                    DocumentID: '1010', // Document ID
                    Value: '1', // Value of the expense
                    Iva: '10', // IVA amount
                    Retraccion: '10', // Retraction amount
                    Concept: 'Concepto 2', // Concept of the expense
                },
            ],
            on: {
                // Event handler for double-click on an item
                onItemDblClick: (id) => {
                    $$('EditExpenses').show(); // Show the edit expenses form
                },
            },
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view components and event handlers.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        /**
         * Initializes variables and configures the popup for adding expenses.
         */
        var url = grid.data.url; // URL for fetching grid data
        const cur_user = this.getParam('user', true); // Retrieves the current user parameter
        var filter = ''; // Filter string for data fetching
        var datePopup3 = []; // Array to store concepts data
        var datePopup4 = []; // Array to store types of center position data
        var popupAdd = ''; // Popup configuration
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2); // Current date in formatted string

        /**
         * Fetches concepts data for the popup form.
         */
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Sets the content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', {
                error: function(text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Displays an error message on failure
                },
                success: function(text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parses the response
                    datePopup3 = resp.Data; // Stores concepts data

                    /**
                     * Fetches types of center position data for the popup form.
                     */
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Sets the content type for the request
                        })
                        .post(devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', '{"Type":2}', {
                            error: function(text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Displays an error message on failure
                            },
                            success: function(text, data, XmlHttpRequest) {
                                var resp = JSON.parse(text); // Parses the response
                                datePopup4 = resp.Data; // Stores types of center position data

                                /**
                                 * Configures and initializes the popup for adding expenses.
                                 */
                                popupAdd = webix.ui({
                                    view: 'window', // Popup window
                                    width: 750, // Width of the popup
                                    id: 'AddExpenses', // Unique ID for the popup
                                    head: {
                                        view: 'toolbar', // Toolbar for the popup header
                                        cols: [
                                            {
                                                view: 'label', // Label for the popup title
                                                label: 'Añadir Gasto',
                                            },
                                            {
                                                view: 'icon', // Close icon
                                                icon: 'wxi-close',
                                                click: function() {
                                                    this.getTopParentView().hide(); // Hides the popup on click
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Centers the popup
                                    modal: true, // Enables modal behavior
                                    body: {
                                        view: 'form', // Form inside the popup
                                        id: 'addform', // Unique ID for the form
                                        elements: [
                                            {
                                                margin: 10, // Margin for the form elements
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for description
                                                        label: 'Descripción',
                                                        name: 'Description',
                                                        labelWidth: 140,
                                                        required: true, // Marks the field as required
                                                    },
                                                    {
                                                        view: 'text', // Text input for creation date
                                                        label: 'Fecha de Creación',
                                                        labelWidth: 140,
                                                        name: 'CreatedLocalDate',
                                                        value: createdLocalDate, // Pre-filled with the current date
                                                        readonly: true, // Read-only field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Dropdown for expense type
                                                        label: 'Tipo de Egreso',
                                                        name: 'TypeEgress',
                                                        labelWidth: 140,
                                                        options: datePopup4, // Options fetched from the server
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Dropdown for concept
                                                        label: 'Concepto',
                                                        name: 'Concept',
                                                        labelWidth: 140,
                                                        options: datePopup3, // Options fetched from the server
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for document ID
                                                        label: 'Documento ID',
                                                        name: 'DocumentID',
                                                        labelWidth: 140,
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for value
                                                        label: 'Valor',
                                                        name: 'Value',
                                                        type: 'number', // Numeric input
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for IVA
                                                        label: 'IVA',
                                                        name: 'Iva',
                                                        type: 'number', // Numeric input
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for retraction
                                                        label: 'Retracción',
                                                        name: 'Retraccion',
                                                        type: 'number', // Numeric input
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button', // Cancel button
                                                        value: 'Cancelar',
                                                        click: function() {
                                                            this.getTopParentView().hide(); // Hides the popup
                                                            $$('addform').setValues($$('addform').getCleanValues()); // Resets the form
                                                        },
                                                    },
                                                    {
                                                        view: 'button', // Save button
                                                        type: 'form',
                                                        value: 'Guardar',
                                                        click: function($e) {
                                                            var values = $$('addform').getValues(); // Retrieves form values
                                                            if ($$('addform').validate()) {
                                                                // Validates the form
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Sets content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() + 'BetShop/Expenses', // API endpoint
                                                                        '{"Description":"' +
                                                                        values.Description +
                                                                        '", "CreatedLocalDate":"' +
                                                                        values.CreatedLocalDate +
                                                                        '", "TypeEgress":"' +
                                                                        values.TypeEgress +
                                                                        '"  , "BetShop":"' +
                                                                        cur_user +
                                                                        '" , "Concept":"' +
                                                                        values.Concept +
                                                                        '" , "DocumentID":"' +
                                                                        values.DocumentID +
                                                                        '"  , "Value":"' +
                                                                        values.Value +
                                                                        '", "Iva":"' +
                                                                        values.Iva +
                                                                        '", "Retraccion":"' +
                                                                        values.Retraccion +
                                                                        '"}',
                                                                        {
                                                                            error: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Error! '); // Displays error message
                                                                            },
                                                                            success: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Gasto Agregado'); // Success message
                                                                                grid.clearAll(); // Clears the grid
                                                                                grid.load(
                                                                                    url +
                                                                                    '?start=0&count=' +
                                                                                    grid.data.$pagesize +
                                                                                    filter,
                                                                                );
                                                                                webix
                                                                                    .ui({
                                                                                        view: 'window',
                                                                                        head: {
                                                                                            view: 'toolbar',
                                                                                            cols: [
                                                                                                {
                                                                                                    view: 'label',
                                                                                                    label: 'Factura',
                                                                                                },
                                                                                                {
                                                                                                    view: 'button',
                                                                                                    label: 'X',
                                                                                                    width: 100,
                                                                                                    align: 'right',
                                                                                                    click: '$(\'windowfact2\').close();',
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                        id: 'windowfact2',
                                                                                        modal: true,
                                                                                        position: 'center',
                                                                                        body: {
                                                                                            rows: [
                                                                                                {
                                                                                                    template:
                                                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>',
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                    })
                                                                                    .show();
                                                                                var reader = new FileReader();
                                                                                reader.onload = function(event) {
                                                                                    $$('pdf').clear();
                                                                                    $$('pdf').parse({
                                                                                        data: event.target.result,
                                                                                    });
                                                                                };

                                                                                function b64toBlob(
                                                                                    b64Data,
                                                                                    contentType,
                                                                                    sliceSize,
                                                                                ) {
                                                                                    contentType = contentType || '';
                                                                                    sliceSize = sliceSize || 512;
                                                                                    var byteCharacters = atob(b64Data);
                                                                                    var byteArrays = [];
                                                                                    for (
                                                                                        var offset = 0;
                                                                                        offset < byteCharacters.length;
                                                                                        offset += sliceSize
                                                                                    ) {
                                                                                        var slice =
                                                                                            byteCharacters.slice(
                                                                                                offset,
                                                                                                offset + sliceSize,
                                                                                            );
                                                                                        var byteNumbers = new Array(
                                                                                            slice.length,
                                                                                        );
                                                                                        for (
                                                                                            var i = 0;
                                                                                            i < slice.length;
                                                                                            i++
                                                                                        ) {
                                                                                            byteNumbers[i] =
                                                                                                slice.charCodeAt(i);
                                                                                        }
                                                                                        var byteArray = new Uint8Array(
                                                                                            byteNumbers,
                                                                                        );
                                                                                        byteArrays.push(byteArray);
                                                                                    }
                                                                                    var blob = new Blob(byteArrays, {
                                                                                        type: contentType,
                                                                                    });
                                                                                    return blob;
                                                                                }

                                                                                var contentType = 'application/pdf';
                                                                                var b64Data = data.Pdf;
                                                                                var blob = b64toBlob(
                                                                                    b64Data,
                                                                                    contentType,
                                                                                );
                                                                                var file =
                                                                                    window.URL.createObjectURL(blob);
                                                                                console.log(blob);
                                                                                document.querySelector('iframe').src =
                                                                                    file;
                                                                                var printWindow = window.open(
                                                                                    file,
                                                                                    '',
                                                                                    'width=800,height=500',
                                                                                );
                                                                                printWindow.print();
                                                                            },
                                                                        },
                                                                    );
                                                                $$('addform').setValues($$('addform').getCleanValues()); // Resets the form
                                                                this.getTopParentView().hide(); // Hides the popup
                                                            } else {
                                                                webix.message({
                                                                    title: '¡Error!',
                                                                    type: 'alert-error',
                                                                    text: 'Completa los campos...', // Validation error message
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function() {
                                                    this.validate(); // Validates the form on change
                                                },
                                            },
                                        },
                                    },
                                });
                            },
                        });
                },
            });

        // Event listener for filtering expenses
        this.on(this.app, 'expense:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize query string

            // Iterate through each entry in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle CreatedLocalDate filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        // Handle ModifiedLocalDate filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to query
                        } else {
                            // Add other filters to query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle case where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' + // Format year
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' + // Format month
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' + // Format day
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' + // Format hours
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' + // Format minutes
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' + // Format year
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' + // Format month
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' + // Format day
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' + // Format hours
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' + // Format minutes
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user ID to query
            grid.clearAll(); // Clear existing grid data
            // Load new data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the filter string for future reference
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                '?start=0&count=' +
                grid.data.$pagesize + // Number of items per page
                filter + // Additional filter parameters
                '&sort[' +
                by + // Sort by the specified column
                ']=' +
                dir, // Sort direction (ascending or descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function(id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item using its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Listen for the 'player:select' event from the application context
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected player's ID
            grid.load(
                grid.data.url +
                '?start=0&count=' +
                grid.data.$pagesize + // Number of items per page
                '&PlayerId=' +
                Id, // Filter by the selected player's ID
            );
        });
        // Create a popup window for editing expenses
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            width: 750, // Set the width of the window
            id: 'EditExpenses', // Unique identifier for the window
            head: {
                // Header configuration for the window
                view: 'toolbar', // Define the header as a toolbar
                cols: [
                    // Columns in the toolbar
                    { view: 'label', label: 'Editar Gasto' }, // Label for the window title
                    {
                        view: 'icon', // Icon button to close the window
                        icon: 'wxi-close', // Icon type
                        click: function() {
                            // Click event to hide the window
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                // Body configuration of the window
                view: 'form', // Define the body as a form
                id: 'editForm', // Unique identifier for the form
                elements: [
                    // Form elements
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the first row of the form
                            {
                                view: 'text', // Text input for ID
                                label: 'ID', // Label for the input
                                name: 'Id', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for Description
                                label: 'Descripción', // Label for the input
                                name: 'Description', // Name of the input field
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the second row of the form
                            {
                                view: 'text', // Text input for Creation Date
                                label: 'Fecha de Creación', // Label for the input
                                labelWidth: 140, // Width of the label
                                name: 'CreatedLocalDate', // Name of the input field
                                readonly: true, // Make the input read-only
                            },
                            {
                                view: 'text', // Text input for Type of Egress
                                label: 'Tipo de Egreso', // Label for the input
                                name: 'TypeEgress', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the third row of the form
                            {
                                view: 'text', // Text input for Document ID
                                label: 'Documento ID', // Label for the input
                                name: 'DocumentID', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the fourth row of the form
                            {
                                view: 'combo', // Combo box for Concept
                                label: 'Concepto', // Label for the input
                                name: 'Concept', // Name of the input field
                                labelWidth: 140, // Width of the label
                                readonly: true, // Make the input read-only
                            },
                            {
                                view: 'text', // Text input for Value
                                label: 'Valor', // Label for the input
                                name: 'Value', // Name of the input field
                                type: 'number', // Specify input type as number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the fifth row of the form
                            {
                                view: 'text', // Text input for IVA
                                label: 'IVA', // Label for the input
                                name: 'Iva', // Name of the input field
                                type: 'number', // Specify input type as number
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for Retracción
                                label: 'Retracción', // Label for the input
                                name: 'Retraccion', // Name of the input field
                                type: 'number', // Specify input type as number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        cols: [
                            // Columns for the buttons
                            {
                                view: 'button', // Button for Cancel
                                value: 'Cancelar', // Button label
                                click: function() {
                                    // Click event for the button
                                    this.getTopParentView().hide(); // Hide the window
                                   $$('editForm').setValues(
                                        // Reset form values
                                       $$('editForm').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Button for Save
                                type: 'form', // Specify button type as form
                                value: 'Guardar', // Button label
                                click: function($e) {
                                    // Click event for the button
                                    var values =$$('editForm').getValues(); // Get form values
                                    webix // Perform an AJAX request
                                        .ajax()
                                        .headers({
                                            // Set request headers
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            // Send POST request
                                            devConfig.geturlApi() + // API URL
                                            'BetShop/Expenses',
                                            '{"Id":"' + // JSON payload
                                            values.Id +
                                            '", "IsBetShop":"' +
                                            values.IsBetShop +
                                            '", "Description":"' +
                                            values.Description +
                                            '", "CreatedLocalDate":"' +
                                            values.CreatedLocalDate +
                                            '", "TypeEgress":"' +
                                            values.TypeEgress +
                                            '"  , "BetShop":"' +
                                            cur_user +
                                            '"  , "DocumentID":"' +
                                            values.DocumentID +
                                            '"  , "Value":"' +
                                            values.Value +
                                            '", "Iva":"' +
                                            values.Iva +
                                            '", "Retraccion":"' +
                                            values.Retraccion +
                                            '"}',
                                            {
                                                error: function(
                                                    // Error callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function(
                                                    // Success callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(
                                                        // Show success message
                                                        'Gasto Actualizado',
                                                    );
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(
                                                        // Reload the grid data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                   $$('editForm').setValues(
                                        // Reset form values
                                       $$('editForm').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Listen for the 'AddExpense:button' event on the application instance
        this.on(this.app, 'AddExpense:button', (filter) => {
            // Clear any validation errors on the 'addform' component
            $$('addform').clearValidation();
            // Show the popup for adding a new expense
            popupAdd.show();
        });
        // Bind the 'editForm' component to the 'datatable' component for data synchronization
       $$('editForm').bind($$('datatable')); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
